var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"text-m font-bold",on:{"click":function($event){_vm.isHidden = !_vm.isHidden}}},[_vm._v(_vm._s(_vm.question))]),(!_vm.isHidden)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.answer)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }